module.exports = __webpack_public_path__ + "img/ts_2012.0d1b0c24.jpg";